export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" stroke=\"#474747\" stroke-width=\"2\" d=\"M22 4.615c6.914 0 11.409 7.146 11.995 12.847.585 5.702 6.38 15.291 6.38 20.658 0 19.598-17.619 20.024-18.375 20.034-.756-.01-18.375-.436-18.375-20.034 0-5.367 5.795-14.956 6.38-20.658C10.591 11.761 15.086 4.615 22 4.615z\" clip-rule=\"evenodd\"/><path fill=\"#fff\" fill-rule=\"evenodd\" stroke=\"#474747\" stroke-width=\"2\" d=\"M22 49.846c-4.97 0-9-4.753-9-10.615 0-5.863 4.03-10.616 9-10.616s9 4.753 9 10.616c0 5.862-4.03 10.615-9 10.615z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "45",
    "height": "60",
    "fill": "none",
    "viewBox": "0 0 45 60"
  }
};